interface ErrorResponse {
    code: number;
    message: string;
}

export interface QuickbetXTrackingState {
    quickbetXTrackingeData: any;
    quickbetXTrackingeLoading: boolean;
    quickbetXTrackingeError: ErrorResponse | null;
}


export enum QuickbetXTrackingActionTypes {
    FETCH_QUICKBET_X_TRACKING_DATA = "FETCH_QUICKBET_X_TRACKING_DATA",
    FETCH_QUICKBET_X_TRACKING_DATA_SUCCESS = "FETCH_QUICKBET_X_TRACKING_DATA_SUCCESS",
    FETCH_QUICKBET_X_TRACKING_DATA_ERROR = "FETCH_QUICKBET_X_TRACKING_DATA_ERROR",
}

export type QuickbetXTrackingAction =
    | { type: QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA }
    | { type: QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA_SUCCESS; payload: any[] }
    | { type: QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA_ERROR; payload: any };